import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setGlossaryModel } from "@/lib/i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => { if (user) setGlossaryModel(user.company_org_model); }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };
  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };
  const setViewRole = async (view_role) => {
    const { data } = await api.patch("/auth/view-role", { view_role });
    setUser(data);
    return data;
  };

  // Effektiv roll: ägare kan förhandsvisa gränssnitt i annan roll (backend-behörighet oförändrad)
  const effectiveRole = user && user.role === "owner" && user.view_role ? user.view_role : user?.role;

  return (
    <AuthCtx.Provider value={{ user, effectiveRole, login, register, logout, refreshUser, setViewRole }}>
      {children}
    </AuthCtx.Provider>
  );
}
export const useAuth = () => useContext(AuthCtx);
